var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalytics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 91,
    viewBox: "0 0 68 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.0007 19.2878L48.1885 3.38238C46.4002 1.69057 44.0596 0.758972 41.598 0.758972H9.58974C4.30196 0.758972 0 5.06093 0 10.3487V80.441C0 85.7288 4.30196 90.0308 9.58974 90.0308H58.4103C63.698 90.0308 68 85.7288 68 80.441V26.2541C68 23.6302 66.9068 21.091 65.0007 19.2878V19.2878ZM59.9204 21.682H46.9026C46.4219 21.682 46.0308 21.291 46.0308 20.8103V8.54166L59.9204 21.682ZM58.4103 84.8H9.58974C7.18621 84.8 5.23077 82.8446 5.23077 80.441V10.3487C5.23077 7.94518 7.18621 5.98974 9.58974 5.98974H40.8V20.8103C40.8 24.1752 43.5376 26.9128 46.9026 26.9128H62.7692V80.441C62.7692 82.8446 60.8138 84.8 58.4103 84.8Z",
    fill: "#CACEAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6564 35.6308H14.2974C12.853 35.6308 11.6821 36.8018 11.6821 38.2462C11.6821 39.6905 12.853 40.8615 14.2974 40.8615H52.6564C54.1008 40.8615 55.2718 39.6905 55.2718 38.2462C55.2718 36.8018 54.1008 35.6308 52.6564 35.6308Z",
    fill: "#CACEAC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6564 49.5795H14.2974C12.853 49.5795 11.6821 50.7505 11.6821 52.1949C11.6821 53.6393 12.853 54.8103 14.2974 54.8103H52.6564C54.1008 54.8103 55.2718 53.6393 55.2718 52.1949C55.2718 50.7505 54.1008 49.5795 52.6564 49.5795Z",
    fill: "#CACEAC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9768 63.5282H14.2974C12.853 63.5282 11.6821 64.6992 11.6821 66.1436C11.6821 67.588 12.853 68.759 14.2974 68.759H26.9768C28.4212 68.759 29.5922 67.588 29.5922 66.1436C29.5922 64.6992 28.4212 63.5282 26.9768 63.5282Z",
    fill: "#CACEAC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.12e835c796f608c6cb2ca36ba9fbadbc.svg";
export { ForwardRef as ReactComponent };